import { useNavigate } from 'react-router-dom';
import Column from 'components/Column';
import {
  Container,
  Thumb,
  StyledImage,
  TopLabel,
  Label,
  InfoContainer,
  InfoTitle,
  InfoDescription,
  NotAvailable,
} from './styled';
import theme from 'config/theme';
import { optimizeCloudinaryUrl } from 'services/cloudinary';

export const CuadroCard = ({ cuadro }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/detail/${cuadro.id}`);
  };

  return (
    <Container onClick={handleClick}>
      <Thumb>
        {cuadro.label.toLowerCase() === 'no disponible' && (
          <NotAvailable>
            <Label $color={theme.colors.white}>No disponible</Label>
          </NotAvailable>
        )}
        <StyledImage src={optimizeCloudinaryUrl(cuadro.image_url || '', 800)} />
        {cuadro.label && cuadro.label.toLowerCase() !== 'no disponible' && (
          <TopLabel $justifyContent="space-between">
            <Label>{cuadro.label}</Label>
          </TopLabel>
        )}
        <InfoContainer $justifyContent="space-between">
          <Column>
            <InfoTitle>{cuadro.name}</InfoTitle>
            <InfoDescription dangerouslySetInnerHTML={{ __html: cuadro.description }} />
            <InfoDescription>{cuadro.price}</InfoDescription>
          </Column>
        </InfoContainer>
      </Thumb>
    </Container>
  );
};
